
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar, Users, Dumbbell } from "lucide-react";

interface ProgramHeaderProps {
  programName: string;
  startDate?: string;
  tier: string;
  clientCount: number;
}

export function ProgramHeader({
  programName,
  startDate,
  tier,
  clientCount
}: ProgramHeaderProps) {
  const navigate = useNavigate();
  
  return (
    <div className="animate-fade-in mb-6">
      <div>
        <Button
          variant="ghost"
          onClick={() => navigate('/programs')}
          className="text-white hover:bg-white/10 -ml-3 mb-2"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Programs
        </Button>
        <h1 className="text-3xl font-bold tracking-tight text-white">{programName}</h1>
        <div className="flex items-center gap-4 mt-2">
          <div className="flex items-center text-white/70">
            <Calendar className="h-4 w-4 mr-1" />
            {startDate || 'No start date'}
          </div>
          <div className="flex items-center text-white/70">
            <Dumbbell className="h-4 w-4 mr-1" />
            {tier} Tier
          </div>
          <div className="flex items-center text-white/70">
            <Users className="h-4 w-4 mr-1" />
            {clientCount} {clientCount === 1 ? 'client' : 'clients'}
          </div>
        </div>
      </div>
    </div>
  );
}
